/**
 * Meta Pixel Event Tracking
 * Centralized tracking functions for Meta Pixel standard events
 */

// Check if fbq is available
function isMetaPixelLoaded() {
  return typeof fbq !== 'undefined';
}

// Meta Pixel Event Tracking Functions
const MetaPixelEvents = {
  /**
   * Track Add to Cart event
   * @param {Object} data - Product data
   * @param {string} data.content_name - Product name
   * @param {string} data.content_ids - Product ID
   * @param {string} data.content_type - Product type
   * @param {number} data.value - Product value
   * @param {string} data.currency - Currency code
   */
  trackAddToCart(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'AddToCart', {
        content_name: data.content_name || '',
        content_ids: data.content_ids || [],
        content_type: data.content_type || 'product',
        value: data.value || 0.00,
        currency: data.currency || 'USD'
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackAddToCart(data).catch(err => {
        console.error('Conversions API AddToCart error:', err);
      });
    }
  },

  /**
   * Track View Content event
   * @param {Object} data - Content data
   */
  trackViewContent(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'ViewContent', {
        content_name: data.content_name || '',
        content_ids: data.content_ids || [],
        content_type: data.content_type || 'product',
        value: data.value || 0.00,
        currency: data.currency || 'USD'
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackViewContent(data).catch(err => {
        console.error('Conversions API ViewContent error:', err);
      });
    }
  },

  /**
   * Track Search event
   * @param {string} searchString - Search query
   */
  trackSearch(searchString) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Search', {
        search_string: searchString || ''
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackSearch(searchString).catch(err => {
        console.error('Conversions API Search error:', err);
      });
    }
  },

  /**
   * Track Initiate Checkout event
   * @param {Object} data - Checkout data
   */
  trackInitiateCheckout(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'InitiateCheckout', {
        value: data.value || 0.00,
        currency: data.currency || 'USD',
        num_items: data.num_items || 0
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackInitiateCheckout(data).catch(err => {
        console.error('Conversions API InitiateCheckout error:', err);
      });
    }
  },

  /**
   * Track Purchase event
   * @param {Object} data - Purchase data
   */
  trackPurchase(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Purchase', {
        value: data.value || 0.00,
        currency: data.currency || 'USD',
        content_ids: data.content_ids || [],
        content_type: data.content_type || 'product',
        num_items: data.num_items || 0
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackPurchase(data).catch(err => {
        console.error('Conversions API Purchase error:', err);
      });
    }
  },

  /**
   * Track Add Payment Info event
   */
  trackAddPaymentInfo() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'AddPaymentInfo');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackAddPaymentInfo().catch(err => {
        console.error('Conversions API AddPaymentInfo error:', err);
      });
    }
  },

  /**
   * Track Add to Wishlist event
   * @param {Object} data - Product data
   */
  trackAddToWishlist(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'AddToWishlist', {
        content_name: data.content_name || '',
        content_ids: data.content_ids || [],
        content_type: data.content_type || 'product',
        value: data.value || 0.00,
        currency: data.currency || 'USD'
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackAddToWishlist(data).catch(err => {
        console.error('Conversions API AddToWishlist error:', err);
      });
    }
  },

  /**
   * Track Complete Registration event
   */
  trackCompleteRegistration() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'CompleteRegistration');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackCompleteRegistration().catch(err => {
        console.error('Conversions API CompleteRegistration error:', err);
      });
    }
  },

  /**
   * Track Contact event
   */
  trackContact() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Contact');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackContact().catch(err => {
        console.error('Conversions API Contact error:', err);
      });
    }
  },

  /**
   * Track Customize Product event
   */
  trackCustomizeProduct() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'CustomizeProduct');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackCustomizeProduct().catch(err => {
        console.error('Conversions API CustomizeProduct error:', err);
      });
    }
  },

  /**
   * Track Donate event
   * @param {Object} data - Donation data
   */
  trackDonate(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Donate', {
        value: data.value || 0.00,
        currency: data.currency || 'USD'
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackDonate(data).catch(err => {
        console.error('Conversions API Donate error:', err);
      });
    }
  },

  /**
   * Track Find Location event
   */
  trackFindLocation() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'FindLocation');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackFindLocation().catch(err => {
        console.error('Conversions API FindLocation error:', err);
      });
    }
  },

  /**
   * Track Lead event
   */
  trackLead() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Lead');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackLead().catch(err => {
        console.error('Conversions API Lead error:', err);
      });
    }
  },

  /**
   * Track Schedule event
   */
  trackSchedule() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Schedule');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackSchedule().catch(err => {
        console.error('Conversions API Schedule error:', err);
      });
    }
  },

  /**
   * Track Start Trial event
   * @param {Object} data - Trial data
   */
  trackStartTrial(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'StartTrial', {
        value: data.value || '0.00',
        currency: data.currency || 'USD',
        predicted_ltv: data.predicted_ltv || '0.00'
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackStartTrial(data).catch(err => {
        console.error('Conversions API StartTrial error:', err);
      });
    }
  },

  /**
   * Track Submit Application event
   */
  trackSubmitApplication() {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'SubmitApplication');
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackSubmitApplication().catch(err => {
        console.error('Conversions API SubmitApplication error:', err);
      });
    }
  },

  /**
   * Track Subscribe event
   * @param {Object} data - Subscription data
   */
  trackSubscribe(data = {}) {
    // Client-side Pixel tracking
    if (isMetaPixelLoaded()) {
      fbq('track', 'Subscribe', {
        value: data.value || '0.00',
        currency: data.currency || 'USD',
        predicted_ltv: data.predicted_ltv || '0.00'
      });
    }
    
    // Server-side Conversions API tracking
    if (window.ConversionsAPI) {
      window.ConversionsAPI.trackSubscribe(data).catch(err => {
        console.error('Conversions API Subscribe error:', err);
      });
    }
  }
};

// Make it globally available
window.MetaPixelEvents = MetaPixelEvents;

